import { render, staticRenderFns } from "./VerticalPornHub.vue?vue&type=template&id=506a7800&scoped=true&"
import script from "./VerticalPornHub.vue?vue&type=script&lang=js&"
export * from "./VerticalPornHub.vue?vue&type=script&lang=js&"
import style0 from "./VerticalPornHub.vue?vue&type=style&index=0&id=506a7800&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a7800",
  null
  
)

export default component.exports